<div class="modal-content" [ngClass]="{ 'anpp': isAnpp }">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">
      <fa-icon icon="plus-square" class="primary-icon"></fa-icon>
      @if (!modifierBlocBool) {
        <b translate> page.inventaire-verger.modals.add-bloc.addBlocTitle</b>
      } @else {
        <b translate> page.inventaire-verger.modals.add-bloc.modifBlocTitle</b>
      }
    </h5>

    <div class="pointer ms-auto" data-dismiss="modal" aria-label="Close">
      <fa-icon icon="times" (click)="cancel()" (keydown.enter)="cancel()"></fa-icon>
    </div>
  </div>
  <div class="modal-body">
    <ul ngbNav class="nav-tabs" #mainNav="ngbNav" (navChange)="beforeChange($event, mainNav)">
      <li ngbNavItem="1">
        <button ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.localisationTitle'|translate }}</button>
        <ng-template ngbNavContent>
          <div ngbAccordion [destroyOnHide]='false' [closeOthers]="true" #shadow="ngbAccordion">

            <!-- ================= PANEL : Liste localisations ================= -->
            <div ngbAccordionItem  id="panelListeLocalisation" [collapsed]="activePanel !== 'panelListeLocalisation'">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton (click)="setActivePanel('panelListeLocalisation')">
                  {{'page.inventaire-verger.modals.add-bloc.panelTitleListeLoca'|translate }}
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div class="accordion-body pt-0">
                  <div class="mb-3">
                    <table  class="table table-striped" aria-label="Liste des localisations">
                      <thead>
                        <tr>
                          <th></th>
                          <th translate>page.inventaire-verger.modals.add-bloc.operation</th>
                          @if (show('departement')) { <th translate>page.inventaire-verger.departement</th> }
                          @if (show('commune')) { <th translate>page.inventaire-verger.commune</th> }
                          @if (show('lieuDit')) { <th translate>page.inventaire-verger.lieuDit</th> }
                          @if (show('refCadastrale')) { <th translate>page.inventaire-verger.refCadastrale</th> }
                          @if (!isAnpp && show('surfCadastrale')) { <th translate>page.inventaire-verger.surfCadastrale</th> }
                          @if (isAnpp && show('situation')) { <th translate>page.inventaire-verger.situation</th> }
                          @if (isAnpp && show('systemeIrrigation')) { <th translate>page.inventaire-verger.systemeIrrigation</th> }
                          @if (isAnpp && show('protectionGrele')) { <th translate>page.inventaire-verger.protectionGrele</th> }
                          @if (isAnpp && show('protectionGel')) { <th translate>page.inventaire-verger.protectionGel</th> }
                          @if (isAnpp && show('forme')) { <th translate>page.inventaire-verger.forme</th> }
                          @if (isAnpp && show('cultureBio')) { <th translate>page.inventaire-verger.cultureBio</th> }
                          @if (show('nbBloc')) { <th translate>page.inventaire-verger.modals.add-bloc.nbBlocsLoca</th> }
                          <th>
                            <fa-icon class="clickable-icon" icon="ellipsis-h" (click)="showList()"></fa-icon>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (localisations?.length === 0) {
                          <tr>
                            <td colspan="99" class="p-4"><fa-icon icon="exclamation-triangle"></fa-icon>&nbsp;
                              <span translate>page.inventaire-verger.modals.localisations.no_localisations</span>
                            </td>
                          </tr>
                        } @else {
                          @for (localisation of localisations; track localisation.id) {
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input [checked]="localisationCheck === localisation" type="checkbox"
                                         class="form-check-input" id="loca-{{localisation.id}}" name="example1"
                                         (change)="onCheckboxChange(localisation,$event)">
                                  <label class="form-check-label" for="loca-{{localisation.id}}"></label>
                                </div>
                              </td>
                              <td>
                                <div class="btn-group dropright  ">
                                  <div ngbDropdown>
                                    <button class="btn btn-secondary dropdown-toggle btnprimary btn-sm " id="dropdownConfig" ngbDropdownToggle>
                                      <fa-icon icon="cog"></fa-icon>
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                                      <button (click)="modifierLocalisation(localisation)" ngbDropdownItem class="dropdown-item" translate>
                                        <fa-icon icon="pencil-alt"></fa-icon>
                                        page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                                      </button>
                                      <button (click)="supprimerLocalisation(localisation)" ngbDropdownItem class="dropdown-item" translate>
                                        <fa-icon icon="trash-alt"></fa-icon>
                                        page.inventaire-verger.modals.add-bloc.buttonSupprimerLocalisation
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              @if (show('departement')) { <td>{{ localisation.departement}}</td> }
                              @if (show('commune')) { <td>{{ localisation.commune}}</td> }
                              @if (show('lieuDit')) { <td>{{ localisation.lieuDit}}</td> }
                              @if (show('refCadastrale')) { <td>{{ localisation.referenceCadastrale}}</td> }
                              @if (!isAnpp && show('surfCadastrale')) { <td>{{ localisation.surfaceCadastrale}}</td> }
                              @if (isAnpp && show('situation')) { <td>{{ localisation.caracteristiqueParcelle.refSituation ? localisation.caracteristiqueParcelle.refSituation.libelle : ''}}</td> }
                              @if (isAnpp && show('systemeIrrigation')) { <td>{{localisation.caracteristiqueParcelle.refSystemeIrrigation ? localisation.caracteristiqueParcelle.refSystemeIrrigation.libelle : ''}}</td> }
                              @if (isAnpp && show('protectionGrele')) { <td>{{localisation.caracteristiqueParcelle.refProtectionGrele ? localisation.caracteristiqueParcelle.refProtectionGrele.libelle : ''}}</td> }
                              @if (isAnpp && show('protectionGel')) { <td>{{ localisation.caracteristiqueParcelle.refProtectionGel ?localisation.caracteristiqueParcelle.refProtectionGel.libelle : '' }}</td> }
                              @if (isAnpp && show('forme')) { <td>{{ localisation.caracteristiqueParcelle.refForme ? localisation.caracteristiqueParcelle.refForme.libelle : '' }}</td> }
                              @if (isAnpp && show('cultureBio')) { <td>{{ localisation.caracteristiqueParcelle.refCultureBio ? localisation.caracteristiqueParcelle.refCultureBio.libelle : '' }}</td> }
                              @if (show('nbBloc')) { <td>{{ localisation.nbBloc}}</td> }
                              <td></td>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- ================= PANEL : Ajouter localisation ================= -->
            <div ngbAccordionItem id="panelAjouterLocalisation" [collapsed]="activePanel !== 'panelAjouterLocalisation'">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton (click)="setActivePanel('panelListeLocalisation')">
                  {{'page.inventaire-verger.modals.add-bloc.panelTitleAjouterLoca'|translate }}
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div class="accordion-body pt-0">
                  <div class="tabs-wrapper">
                    <ul ngbNav class="nav-tabs mt-2" #localNav="ngbNav" (navChange)="changeTabLoca(localNav)">
                      <li ngbNavItem="localisationGeo">
                        <button ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.panelTitleLocaGeo'|translate }}</button>
                        <ng-template ngbNavContent>
                          <form [formGroup]="controleFormLocalisationGeo" #form="ngForm" (ngSubmit)="submit()" novalidate>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="codePostalLabel" class="form-label" translate>page.inventaire-verger.modals.add-bloc.codePostal</label>
                                  <input id="codePostalLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && codePostal.invalid || (communes && communes.length === 0)}" (keyup)="changeValueCodePostal($event)" type="text"  maxlength="5" formControlName="codePostal"
                                         class="form-control">
                                  @if (form.submitted || form.touched) {
                                    @if (codePostal.errors?.required) {
                                      <div class="form-error" translate>label.obligatoire</div>
                                    }
                                  }
                                  @if (communes && communes.length === 0) {
                                    <div class="form-error" translate>Aucune commune avec ce code postal</div>
                                  }
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="departementLabel" class="form-label" translate>page.inventaire-verger.departement</label>
                                  <select id="departementLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && departement.invalid}" formControlName="departement" class="form-select">

                                    @for (departement of departements; track $index) {
                                      <option
                                            [ngValue]="departement">{{departement.code}} - {{departement.nom}}</option>
                                    }
                                  </select>
                                  @if (form.submitted || form.touched) {
                                    @if (departement.errors?.required) {
                                      <div class="form-error" translate>label.obligatoire</div>
                                    }
                                  }
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="communeLabel" class="form-label" translate>page.inventaire-verger.commune</label>
                                  <select id="communeLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && commune.invalid}" formControlName="commune" class="form-select">
                                    @for (commune of communes; track $index) {
                                      <option [ngValue]="commune">{{commune.nom}}</option>
                                    }
                                  </select>
                                  @if (form.submitted || form.touched) {
                                    @if (commune.errors?.required) {
                                      <div class="form-error" translate>label.obligatoire</div>
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="lieuDitLabel" class="form-label" translate>page.inventaire-verger.lieuDit</label>
                                  <input id="lieuDitLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && lieuDit.invalid}" (keyup)="changeLocalisationGeo()" type="text" formControlName="lieuDit"
                                         class="form-control">
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="refCadastraleLabel" class="form-label" translate>page.inventaire-verger.refCadastrale</label>
                                  <input id="refCadastraleLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && refCadastrale.invalid}" (keyup)="changeLocalisationGeo()" type="text" formControlName="refCadastrale"
                                         class="form-control">
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="situationLabel" class="form-label" translate>page.inventaire-verger.situation</label>
                                  <select id="situationLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && situationLoca.invalid}"  formControlName="situation" class="form-select">
                                    @for (situation of refSituations; track $index) {
                                      <option
                                            [ngValue]="situation">{{situation.libelle}}</option>
                                    }
                                  </select>
                                  @if (form.submitted || form.touched) {
                                    @if (situationLoca.errors?.required) {
                                      <div class="form-error" translate>label.obligatoire</div>
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="mb-3">
                                  <label for="surfCadastraleLabel" class="form-label" translate>page.inventaire-verger.surfCadastrale</label>
                                  <input id="surfCadastraleLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && surfCadastrale.invalid}" (keyup)="changeLocalisationGeo()" type="text" formControlName="surfCadastrale"
                                         class="form-control">
                                </div>
                              </div>
                            </div>
                            @if (isAnpp) {
                              <button (click)=onTabAddLocaChange(localNav) type="button"
                                    class="btn btn-primary"
                                    style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>page.inventaire-verger.modals.add-bloc.buttonSuivant
                                <fa-icon icon="arrow-right" class="primary-icon"></fa-icon>
                              </button>
                            }
                            @if (!this.updateLocalisation && !isAnpp) {
                              <button type="submit"
                                    class="btn btn-primary"
                                    style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                                page.inventaire-verger.modals.add-bloc.buttonAjouterLocalisation
                              </button>
                            }
                            @if (this.updateLocalisation && !isAnpp) {
                              <button type="submit" class="btn btn-primary"
                                    style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                                page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                              </button>
                            }
                          </form>
                        </ng-template>
                      </li>
                      @if (isAnpp) {
                        <li ngbNavItem="equipementsConduite">
                          <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.panelEquipementsConduites'|translate }}</a>
                          <ng-template ngbNavContent>
                            <form [formGroup]="controleFormEquipementConduite" #form="ngForm" (ngSubmit)="submit()" novalidate>
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="systemeIrrigationLabel" class="form-label" translate>page.inventaire-verger.systemeIrrigation</label>
                                    <select id="systemeIrrigationLabel" formControlName="systemeIrrigation" class="form-select">
                                      <option [ngValue]="null"></option>
                                      @for (systemeIrrigation of refSystemeIrrigations; track $index) {
                                        <option
                                              [ngValue]="systemeIrrigation">{{systemeIrrigation.libelle}}</option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="protectionGelLabel" class="form-label" translate>page.inventaire-verger.protectionGel</label>
                                    <select id="protectionGelLabel" formControlName="protectionGel" class="form-select">
                                      <option [ngValue]="null"></option>
                                      @for (protectionGel of refProtectionGels; track $index) {
                                        <option
                                              [ngValue]="protectionGel">{{protectionGel.libelle}}</option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="protectionGreleLabel" class="form-label" translate>page.inventaire-verger.protectionGrele</label>
                                    <select id="protectionGreleLabel" formControlName="protectionGrele" class="form-select">
                                      <option [ngValue]="null"></option>
                                      @for (protectionGrele of refProtectionGreles; track $index) {
                                        <option
                                              [ngValue]="protectionGrele">{{protectionGrele.libelle}}</option>
                                      }
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="cultureBioLabel" class="form-label" translate>page.inventaire-verger.cultureBio</label>
                                    <select id="cultureBioLabel" formControlName="cultureBio" class="form-select">
                                      <option [ngValue]="null"></option>
                                      @for (cultureBio of refCultureBios; track $index) {
                                        <option
                                              [ngValue]="cultureBio">{{cultureBio.libelle}}</option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class="mb-3">
                                    <label for="formeLabel" class="form-label" translate>page.inventaire-verger.forme</label>
                                    <select id="formeLabel" formControlName="forme" class="form-select">
                                      <option [ngValue]="null"></option>
                                      @for (forme of refFormes; track $index) {
                                        <option [ngValue]="forme">{{forme.libelle}}</option>
                                      }
                                    </select>
                                  </div>
                                </div>
                              </div>
                              @if (!this.updateLocalisation) {
                                <button type="submit"
                                      class="btn btn-primary"
                                      style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                                  page.inventaire-verger.modals.add-bloc.buttonAjouterLocalisation
                                </button>
                              }
                              @if (this.updateLocalisation) {
                                <button type="submit" class="btn btn-primary"
                                      style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                                  page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                                </button>
                              }
                            </form>
                          </ng-template>
                        </li>
                      }
                    </ul>
                    <div [ngbNavOutlet]="localNav" class="mt-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="2">
        <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.tracabiliteTitle'|translate }}</a>
        <ng-template ngbNavContent>
          <form [formGroup]="controleFormTracabilite" #form="ngForm" (ngSubmit)="submit()" novalidate>
            <div class="row">
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="numBlocLabel" class="form-label" translate>page.inventaire-verger.numBloc</label>
                  <input id="numBlocLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && numBloc.invalid}" (keyup)="changeTrancabilite()" type="text" formControlName="numBloc"
                         class="form-control">
                </div>
              </div>
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="numTracabiliteLabel" class="form-label" translate>page.inventaire-verger.numDeTracabilite</label>
                    <input id="numTracabiliteLabel" [ngClass]="{'is-invalid':(form.submitted || form.touched) && numTracabilite.invalid}"  (keyup)="changeTrancabilite()" type="text" formControlName="numTracabilite"
                          class="form-control">
                  </div>
                </div>
              }
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="codeParcelleLabel" class="form-label" translate>page.inventaire-verger.codeParcelle</label>
                    <input id="codeParcelleLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && codeParcelle.invalid}" (keyup)="changeTrancabilite()"   type="text" formControlName="codeParcelle"
                          class="form-control">
                  </div>
                </div>
              }
            </div>
          </form>
        </ng-template>
      </li>
      <li ngbNavItem="3">
        <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.botaniqueTitle'|translate }}</a>
        <ng-template ngbNavContent>
          <form [formGroup]="controleFormBotanique" #form="ngForm" (ngSubmit)="submit()" novalidate>
            @if (isAnpp) {
              <div class="row">
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="especeLabel" class="form-label" translate>page.inventaire-verger.espece</label>
                    <select id="especeLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && espece.invalid}" formControlName="espece" class="form-select" (change)="changeValueEspece()">
                      @for (espece of especes; track $index) {
                        <option [ngValue]="espece">{{espece.libelle}}</option>
                      }
                    </select>
                    @if (form.submitted || form.touched) {
                      @if (espece.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="varieteLabel" class="form-label"  translate>page.inventaire-verger.variete</label>
                    <select id="varieteLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && variete.invalid}" formControlName="variete" class="form-select" (change)="changeValueVariete()">
                      <option [ngValue]="null"></option>
                      @for (variete of varietes; track $index) {
                        <option [ngValue]="variete">{{variete.libelle}}</option>
                      }
                    </select>
                    @if (form.submitted || form.touched) {
                      @if (variete.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="cloneLabel" class="form-label" translate>page.inventaire-verger.clone</label>
                    <select id="cloneLabel" formControlName="clone" class="form-select">
                      <option [ngValue]="null"></option>
                      @for (clone of varietesClone; track $index) {
                        <option [ngValue]="clone">{{clone.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }
            <div class="row">
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="varieteLabel2" class="form-label" translate>page.inventaire-verger.cepage</label>
                    <select id="varieteLabel2" [ngClass]="{'is-invalid': (form.submitted || form.touched) && variete.invalid}" formControlName="variete" class="form-select" (change)="changeValueVariete()">
                      <option [ngValue]="null"></option>
                      @for (variete of varietes; track $index) {
                        <option [ngValue]="variete">{{variete.libelle}}</option>
                      }
                    </select>
                    @if (form.submitted || form.touched) {
                      @if (variete.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
              }
              <div class="col-lg-4" >
                <div class="mb-3">
                  <label for="porteGreffeLabel" class="form-label" translate>page.inventaire-verger.porteGreffe</label>
                  <select id="porteGreffeLabel" formControlName="porteGreffe" class="form-select">
                    <option [ngValue]="null"></option>
                    @for (refPorteGreffe of refPorteGreffes; track $index) {
                      <option [ngValue]="refPorteGreffe">{{ refPorteGreffe.libelle }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="anneePlantationLabel" class="form-label" translate>page.inventaire-verger.anneePlantation</label>
                  <input id="anneePlantationLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && anneePlantation.invalid}" (keyup)="changeBotanique()" (keypress)="keyPressNumbers($event)" type="number" min="0"
                         formControlName="anneePlantation" class="form-control">
                  <ng-container>
                    @if (form.submitted || form.touched) {
                      @if (anneePlantation.errors?.max) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                      @if (anneePlantation.errors?.min) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                    }
                  </ng-container>
                </div>
              </div>
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="anneePremiereFeuilleLabel" class="form-label" translate>page.inventaire-verger.anneePremiereFeuille</label>
                    <input id="anneePremiereFeuilleLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && anneePremiereFeuille.invalid}" (keyup)="changeBotanique()" (keypress)="keyPressNumbers($event)" type="number" min="0"
                          formControlName="anneePremiereFeuille" class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (anneePremiereFeuille.errors?.max) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                      @if (anneePremiereFeuille.errors?.min) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
            <div class="row">
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="anneeSurgreffageLabel" class="form-label" translate>page.inventaire-verger.anneeSurgreffage</label>
                    <input id="anneeSurgreffageLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && anneeSurgreffage.invalid}" (keyup)="changeBotanique()" (keypress)="keyPressNumbers($event)" type="number" min="0"
                          formControlName="anneeSurgreffage" class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (anneeSurgreffage.errors?.max) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                      @if (anneeSurgreffage.errors?.min) {
                        <div class="form-error" translate >page.inventaire-verger.modals.add-bloc.formatDateAlert</div>
                      }
                    }
                  </div>
                </div>
              }
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="distanceInterRangLabel" class="form-label" translate>page.inventaire-verger.distanceInterRang</label>
                  <input id="distanceInterRangLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && distanceInterRang.invalid}" (keyup)="arrondirDistance($event); calculeSurface()"  type="number" formControlName="distanceInterRang"
                         class="form-control">
                  <ng-container>
                    @if (form.submitted || form.touched) {
                      @if (distanceInterRang.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                      @if (distanceInterRang.errors?.max) {
                        <div class="form-error" translate [translateParams]="{ maxDistance : maxDistance }">page.inventaire-verger.modals.add-bloc.maxDistanceAlert</div>
                      }
                      @if (distanceInterRang.errors?.min) {
                        <div class="form-error" translate>page.inventaire-verger.modals.add-bloc.minDistanceAlert</div>
                      }
                    }
                  </ng-container>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="distanceIntraRangLabel" class="form-label" translate>page.inventaire-verger.distanceIntraRang</label>
                  <input id="distanceIntraRangLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && distanceIntraRang.invalid}" (keyup)="arrondirDistance($event); calculeSurface()" type="number" formControlName="distanceIntraRang"
                         class="form-control">
                  <ng-container>
                    @if (form.submitted || form.touched) {
                      @if (distanceIntraRang.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                      @if (distanceIntraRang.errors?.max) {
                        <div class="form-error" translate [translateParams]="{ maxDistance : maxDistance }">page.inventaire-verger.modals.add-bloc.maxDistanceAlert</div>
                      }
                      @if (distanceIntraRang.errors?.min) {
                        <div class="form-error" translate>page.inventaire-verger.modals.add-bloc.minDistanceAlert</div>
                      }
                    }
                  </ng-container>
                </div>
              </div>
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="surfacePlanteeLabel" class="form-label" translate>page.inventaire-verger.surfacePlantee</label>
                    <input id="surfacePlanteeLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && surfacePlantee.invalid}" (keyup)="arrondirDistance($event);" type="number" formControlName="surfacePlantee"
                          class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (surfacePlantee.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
            <div class="row">
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="nbArbreLabel" class="form-label" translate>page.inventaire-verger.nombreArbre</label>
                    <input id="nbArbreLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && nbArbre.invalid}" (keyup)="calculeSurface()" (keypress)="keyPressNumbers($event)" min="0" type="number" formControlName="nbArbre" class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (nbArbre.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
              }
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="densiteLabel" class="form-label" translate>page.inventaire-verger.densite</label>
                    <input id="densiteLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && densite.invalid}" type="number" formControlName="densite"
                          class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (densite.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
              }
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="manquantLabel" class="form-label" translate>page.inventaire-verger.manquant</label>
                    <input id="manquantLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && manquant.invalid}" type="number" formControlName="manquant"
                          class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (manquant.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
            <hr>
            @if (isAnpp) {
              <div class="row">
                <div class="col-lg-12 text-center">
                  <ng-template #htmlContent ><span [innerHtml]="'page.inventaire-verger.modals.add-bloc.surfaceTooltip'|translate"></span></ng-template>
                  <span href="#" [ngbTooltip]="htmlContent" tooltipClass="text-start">

                  <div class="  pt-2 m-2"
                      style="width:90%;display:inline-block;border-radius:15px;line-height:30px;border:1px solid  rgba(131,187,38,1); background:rgba(131,187,38,0.15);">
                    <b style="font-size:25px" translate> <fa-icon icon="info-circle"></fa-icon> page.inventaire-verger.surfaceHa <span
                      style="font-size:25px;color:rgba(131,187,38,1)">{{this.surfaceHa|number:'1.0-3' }} Ha</span></b><br/>
                  </div>
                    </span>
                </div>
              </div>
            }
          </form>
        </ng-template>
      </li>
      <li ngbNavItem="4">
        <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.caracteristiqueTitle'|translate }}</a>
        <ng-template ngbNavContent>
          <form [formGroup]="controleFormCaracteristique" #form="ngForm" (ngSubmit)="submit()" novalidate>
            <div class="row">
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="systemeIrrigationLabel2" class="form-label" translate>page.inventaire-verger.systemeIrrigation</label>
                    <select id="systemeIrrigationLabel2" formControlName="systemeIrrigation" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (systemeIrrigation of refSystemeIrrigations; track $index) {
                        <option [ngValue]="systemeIrrigation">{{ systemeIrrigation.libelle }}</option>
                      }
                    </select>
                </div>
              </div>
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="protectionGelLabel2" class="form-label" translate>page.inventaire-verger.protectionGel</label>
                    <select id="protectionGelLabel2" formControlName="protectionGel" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (protectionGel of refProtectionGels; track $index) {
                        <option
                              [ngValue]="protectionGel">{{protectionGel.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="protectionGreleLabel2" class="form-label" translate>page.inventaire-verger.protectionGrele</label>
                    <select id="protectionGreleLabel2" formControlName="protectionGrele" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (protectionGrele of refProtectionGreles; track $index) {
                        <option
                              [ngValue]="protectionGrele">{{protectionGrele.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="modeConduiteLabel" class="form-label" translate>page.inventaire-verger.modeConduite</label>
                    <select id="modeConduiteLabel" formControlName="modeConduite" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (modeConduite of refModeConduites; track $index) {
                        <option
                              [ngValue]="modeConduite">{{modeConduite.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (!isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="derogationTailleLabel" class="form-label" translate>page.inventaire-verger.derogationTaille</label>
                    <input id="derogationTailleLabel" type="checkbox" formControlName="derogationTaille" class="form-control" style="width:30%">
                  </div>
                </div>
              }
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="mb-3">
                  <label for="cultureBioLabel2" class="form-label" translate>page.inventaire-verger.cultureBio</label>
                    <select id="cultureBioLabel2" formControlName="cultureBio" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (cultureBio of refCultureBios; track $index) {
                        <option
                              [ngValue]="cultureBio">{{cultureBio.libelle}}</option>
                      }
                    </select>
                </div>
              </div>
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="formeLabel2" class="form-label" translate>page.inventaire-verger.forme</label>
                    <select id="formeLabel2" formControlName="forme" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (forme of refFormes; track $index) {
                        <option [ngValue]="forme">{{forme.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="situationLabel2" class="form-label" translate>page.inventaire-verger.situation</label>
                    <select id="situationLabel2" formControlName="situation" class="form-select" (change)="manualChange=true">
                      <option [ngValue]="null"></option>
                      @for (situation of refSituations; track $index) {
                        <option [ngValue]="situation">{{situation.libelle}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
            </div>
            <div class="row">
              @if (isAnpp) {
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="confusionCheck" class="form-label" translate>page.inventaire-verger.confusion</label>
                      <div class="form-check">
                          <input id="confusionCheck" type="checkbox" formControlName="confusion" class="form-check-input">
                      </div>
                  </div>
                </div>
              }

            </div>
          </form>
        </ng-template>
      </li>
      @if (!isAnpp) {
        <li ngbNavItem="5">
          <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.destinationTitle'|translate }}</a>
          <ng-template ngbNavContent>
            <form [formGroup]="controleFormDestination" #form="ngForm" (ngSubmit)="submit()" novalidate>
              <div class="row">
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label class="form-label" for="destinationVin" translate>page.inventaire-verger.modals.add-bloc.destination</label><br />
                        <select formControlName="destinationVendange" (change)="changeValueDestination($event.target.value)" class="form-select">
                          <option [ngValue]="null">Choisir</option>
                          @for (destinationKey of enumKeys; track $index) {
                            <option [ngValue]="destinationKey">
                              {{ destinations[destinationKey] }}
                            </option>
                          }
                        </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="mb-3">
                    <label for="destinataireLabel" class="form-label" translate>page.inventaire-verger.destinataire</label>
                    <app-search-entreprise-categorie-bar [categorie]="this.destinationVendange.value" [entreprise]="this.destinataire"  (newItemEvent)="selectItem($event)">
                    </app-search-entreprise-categorie-bar>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="col-lg-4">
                <div class="mb-3">
                  <label class="form-label" for="cahier" translate>page.declarations.synthese.modal.saisir-revendication.cahier</label>
                  <select formControlName="cahier" class="form-select" (change)="loadProducts()" [ngClass]="{'is-invalid': form.submitted && form.invalid}">
                    @for (cahierD of cahiers; track $index) {
                      <option [ngValue]="cahierD">{{ cahierD?.libelle }}</option>
                    }
                  </select>
                </div>
                </div>
                <div class="col-lg-4">
                <div class="mb-3">
                  <label class="form-label" for="identifie" translate>page.inventaire-verger.produitIdentifie</label>
                  <select formControlName="identifie" class="form-select" (change)="loadProduitsDestination()" [ngClass]="{'is-invalid': form.submitted && form.invalid}">
                    @for (produit of produitIdentifies; track $index) {
                      <option [ngValue]="produit">{{ produit.libelle }}</option>
                    }
                  </select>
                </div>
                </div>
                <div class="col-lg-4">
                <div class="mb-3">
                  <label class="form-label" for="destination" translate>page.inventaire-verger.produitDestination</label>
                  <select formControlName="destination" class="form-select" [ngClass]="{'is-invalid': form.submitted && form.invalid}">
                    @for (produit of produitDestinations; track $index) {
                      <option [ngValue]="produit">{{ produit.libelle }}</option>
                    }
                  </select>
                </div>
                </div>
              </div>
              <div class="row">

                <div class="col-lg-4">
                <div class="mb-3">
                  <label for="surfaceEngageeLabel" class="form-label" translate>page.inventaire-verger.surfaceEngagee</label>
                    <input id="surfaceEngageeLabel" [ngClass]="{'is-invalid': (form.submitted || form.touched) && surfaceEngagee.invalid}"  type="number" formControlName="surfaceEngagee"
                          class="form-control">
                    @if (form.submitted || form.touched) {
                      @if (surfaceEngagee.errors?.required) {
                        <div class="form-error" translate>label.obligatoire</div>
                      }
                    }
                    @if (form.submitted || form.touched) {
                      @if (verifSurfacePlantee()) {
                        <div class="form-error" translate>page.inventaire-verger.modals.add-bloc.surfaceEngageeAlert</div>
                      }
                    }
                </div>
                </div>
              </div>
            </form>
          </ng-template>
        </li>
      }
      <li ngbNavItem="6">
        <a ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.recapitulatifTitle'|translate }}</a>
        <ng-template ngbNavContent>
          @if (isAnpp) {
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.localisationTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.departement</span>
                <span>: {{localisationCheck?.departement ? localisationCheck.departement:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.commune</span>
                <span>: {{localisationCheck?.commune ? localisationCheck.commune:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.lieuDit</span>
                <span>: {{localisationCheck?.lieuDit ? localisationCheck.lieuDit:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.refCadastrale</span>
                <span>: {{localisationCheck?.referenceCadastrale ? localisationCheck.referenceCadastrale:'N/C'}}</span>
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.tracabiliteTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.numBloc</span>
                <span>: {{numBloc?.value ? numBloc.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.numDeTracabilite</span>
                <span>: {{numTracabilite?.value ? numTracabilite.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.codeParcelle</span>
                <span>: {{codeParcelle?.value ? codeParcelle.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.botaniqueTitle</h5>
            <div class="row">
              <div  class="col-lg-3">
                <span translate>page.inventaire-verger.espece</span>
                <span>: {{espece.value?.libelle ? espece.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.variete</span>
                <span>: {{variete.value?.libelle ? variete.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.clone</span>
                <span>: {{clone.value?.libelle ? clone.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.porteGreffe</span>
                <span>: {{porteGreffe.value?.libelle ? porteGreffe.value.libelle:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.anneePlantation</span>
                <span>: {{anneePlantation?.value ? anneePlantation.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.anneePremiereFeuille</span>
                <span>: {{anneePremiereFeuille?.value ? anneePremiereFeuille.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.anneeSurgreffage</span>
                <span>: {{anneeSurgreffage?.value ? anneeSurgreffage.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.distanceInterRang</span>
                <span>: {{distanceInterRang?.value ? distanceInterRang.value:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.distanceIntraRang</span>
                <span>: {{distanceIntraRang?.value ? distanceIntraRang.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.nombreArbre</span>
                <span>: {{nbArbre?.value ? nbArbre.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.surface</span>
                <span>: {{surfaceHa ? (surfaceHa|number:'1.0-3')  :'N/C'}}</span>
              </div>
              <div class="col-lg-3">
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.caracteristiqueTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.systemeIrrigation</span>
                <span>: {{systemeIrrigationBloc.value?.libelle ? systemeIrrigationBloc.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.protectionGel</span>
                <span>: {{protectionGelBloc.value?.libelle ? protectionGelBloc.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.forme</span>
                <span>: {{formeBloc.value?.libelle ? formeBloc.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.cultureBio</span>
                <span>: {{cultureBioBloc.value?.libelle ? cultureBioBloc.value.libelle:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.protectionGrele</span>
                <span>: {{protectionGreleBloc.value?.libelle ? protectionGreleBloc.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.situation</span>
                <span>: {{situationBloc.value?.libelle ? situationBloc.value.libelle:'N/C'}}</span>
              </div>
              <div class=" col-lg-3">
                <span translate>page.inventaire-verger.confusion</span>
                <span>: {{confusion?.value ? 'Oui':'Non'}}</span>
              </div>
              <div class="col-lg-3">
              </div>
            </div>
          }
          @if (!isAnpp) {
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.localisationTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.departement</span>
                <span>: {{localisationCheck?.departement ? localisationCheck.departement:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.commune</span>
                <span>: {{localisationCheck?.commune ? localisationCheck.commune:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.lieuDit</span>
                <span>: {{localisationCheck?.lieuDit ? localisationCheck.lieuDit:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.refCadastrale</span>
                <span>: {{localisationCheck?.referenceCadastrale ? localisationCheck.referenceCadastrale:'N/C'}}</span>
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.tracabiliteTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.numBloc</span>
                <span>: {{numBloc?.value ? numBloc.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.botaniqueTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.variete</span>
                <span>: {{variete.value?.libelle ? variete.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.porteGreffe</span>
                <span>: {{porteGreffe.value?.libelle ? porteGreffe.value.libelle:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.anneePlantation</span>
                <span>: {{anneePlantation?.value ? anneePlantation.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.distanceInterRang</span>
                <span>: {{distanceInterRang?.value ? distanceInterRang.value:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.distanceIntraRang</span>
                <span>: {{distanceIntraRang?.value ? distanceIntraRang.value:'N/C'}}</span>
              </div>
              <div class="col-lg-3">
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.caracteristiqueTitle</h5>
            <div class="row">
              <div class="col-lg-3">
                <span translate>page.inventaire-verger.systemeIrrigation</span>
                <span>: {{systemeIrrigationBloc.value?.libelle ? systemeIrrigationBloc.value.libelle:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
              </div>
            </div>
            <hr>
            <h5 class="sub-popup-title" translate>page.inventaire-verger.modals.add-bloc.destinationTitle</h5>
            <div class="row">
              <div class="col-lg-4">
                <span translate>page.inventaire-verger.modals.add-bloc.destination</span>
                <span>: {{destinationVendange.value ? destinations[destinationVendange.value] : ''}}</span>
              </div>
              <div class="col-lg-4">
                <span translate>page.inventaire-verger.destinataire</span>
                <span>: {{destinataire?.raisonSociale ? destinataire?.raisonSociale:''}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <span translate>page.inventaire-verger.produitIdentifie</span>
                <span>: {{identifie.value?.libelle ? identifie.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-4">
                <span translate>page.inventaire-verger.produitDestination</span>
                <span>: {{destination.value?.libelle ? destination.value.libelle:'N/C'}}</span>
              </div>
              <div class="col-lg-4">
                <span translate>page.inventaire-verger.surfaceEngagee</span>
                <span>: {{surfaceEngagee.value ? surfaceEngagee.value:'N/C'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
              </div>
            </div>
          }
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="mainNav" class="mt-3"></div>
  </div>
  <div class="modal-footer">
    @if (idTab < idTabMAX) {
      <button (click)=onTabChange(mainNav) [hidden]="hiddenButton" type="button"
              class="btn btn-primary"
              style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>page.inventaire-verger.modals.add-bloc.buttonSuivant
        <fa-icon icon="arrow-right" class="primary-icon"></fa-icon>
      </button>
    }
    @if (idTab >= idTabMAX) {
      <button (click)="submit()" type="submit" class="btn btn-primary"
              style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>page.inventaire-verger.buttonEnregistrer
      </button>
    }
  </div>
</div>
